<template>
  <div>
    <BerandaVendor class="dashboard mt-10"></BerandaVendor>
    <PublicFooter v-if="!currentUserWebinar"></PublicFooter>
  </div>
</template>


  <script>
import BerandaVendor from "@/components/public-marketplace/vendor/BerandaVendor";
import PublicFooter from "@/components/AppFooter.vue";
import ERole from "@/models/e-role";

export default {
  name: "BerandaView",

  components: {
    BerandaVendor,
    PublicFooter,
  },
  computed: {
    currentUserWebinar(){
      if(this.$store.state.auth.user){
        if(this.$store.state.auth.user.roles.includes(ERole.ROLE_USER)){
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

  },
};
</script>
  